import React, { useState, useEffect } from "react";
import TopHeading from "../Heading/TopHeading";
import { Form, Row, Col, Table } from "react-bootstrap";
import ParentItem from "./ParentItem";
import axios from "../../axios";
import { toast } from "react-toastify";
import { Loader, NoContent, Pagination, SearchBar } from "../UI";

export default function ParentsContent() {
  const authToken = localStorage.getItem("access_token");
  const [parents, setParents] = useState([]);
  const [currentParents, setCurrentParents] = useState([]);
  const itemsPerPage = 12;
  const [isLoading, setIsLoading] = useState(true);
  const [nameSearch, setNameSearch] = useState("");
  const [emailSearch, setEmailSearch] = useState("");
  const [postcodeSearch, setPostcodeSearch] = useState("");

  const filterMethods = [
    (item) =>
      (item.firstName + " " + item.lastName)
        .toLowerCase()
        .indexOf(nameSearch.toLowerCase()) != -1,
    (item) => item.email.toLowerCase().indexOf(emailSearch.toLowerCase()) != -1,
    (item) =>
      item.guardianPostcode
        .toLowerCase()
        .indexOf(postcodeSearch.toLowerCase()) != -1,
  ];

  const filteredParents = parents.filter((item) => {
    for (let i = 0; i < filterMethods.length; i++) {
      if (!filterMethods[i](item)) {
        return false;
      }
    }
    return true;
  });

  const handleParentUpdate = (userId, values, setSubmitting) => {
    axios
      .put(`/user-guardians/${userId}`, values, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        setIsLoading(true);
        if (response.data) {
          if (response.status === 200) {
            toast.success("Parent updated successfully!");
            fetchParent();
          } else {
            toast.warn("No response from server");
          }
        }
        setSubmitting(false);
      })
      .catch((error) => {
        toast.error("Couldn't update parent");
        setSubmitting(false);
      });
  };

  const fetchParent = () => {
    axios
      .get("/user-guardians", {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((response) => {
        setParents(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error("Couldn't load parents");
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchParent();
  }, []);

  return (
    <section className="parents-content">
      <div className="container">
        <div className="row g-0">
          <div className="col-md-12">
            <TopHeading title="Parents" />
            <div className="parents light-bg corner-radius p-4 mb-3 main-content custom-scrollbar">
              <div className="">
                <Form>
                  <Row>
                    <Col md="4">
                      <Form.Group className="mb-3">
                        <Form.Label>Parent Name</Form.Label>
                        <SearchBar
                          placeholder="Search Name"
                          value={nameSearch}
                          onChange={(e) => setNameSearch(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group className="mb-3">
                        <Form.Label>Parent Email</Form.Label>
                        <SearchBar
                          placeholder="Search Email"
                          value={emailSearch}
                          onChange={(e) => setEmailSearch(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="4">
                      <Form.Group className="mb-3">
                        <Form.Label>Parent Postcode</Form.Label>
                        <SearchBar
                          placeholder="Search Postcode"
                          value={postcodeSearch}
                          onChange={(e) => setPostcodeSearch(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </div>
              <Table className="list-table align-middle" borderless responsive>
                <thead className="primary-button fw-bold">
                  <tr>
                    <td>Photo</td>
                    <td>Name</td>
                    <td>Email</td>
                    <td>Actions</td>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan={4}>
                        <Loader />
                      </td>
                    </tr>
                  ) : filteredParents.length ? (
                    filteredParents.length > itemsPerPage ? (
                      currentParents.map((item) => {
                        return (
                          <ParentItem
                            key={item.userId}
                            data={item}
                            handleParentUpdate={handleParentUpdate}
                          />
                        );
                      })
                    ) : (
                      filteredParents.map((item) => {
                        return (
                          <ParentItem
                            key={item.userId}
                            data={item}
                            handleParentUpdate={handleParentUpdate}
                          />
                        );
                      })
                    )
                  ) : (
                    <tr>
                      <td colSpan={4}>
                        <NoContent />
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {filteredParents.length > itemsPerPage && (
                <div className="d-flex justify-content-end">
                  <Pagination
                    data={filteredParents}
                    setCurrentItems={setCurrentParents}
                    itemsPerPage={itemsPerPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
